<div class="ef-page">

  <div class="ef-header">
    <div class="ef-header__icon"><mat-icon>shopping_cart</mat-icon></div>
    <div>
      <h1 class="ef-header__title">Nueva factura simplificada</h1>
      <p class="ef-header__sub">Crea un ticket de venta y descarga su PDF al guardar</p>
    </div>

    <div class="cf-total-cards pf-header-totals" *ngIf="!isLoading && lines.length > 0">
      <div class="cf-total-card">
        <p class="label">Subtotal <strong>{{ subtotal | number:'1.2-2' }} €</strong></p>
      </div>
      <div class="cf-total-card cf-total-card--highlight">
        <p class="label">Total <strong>{{ total | number:'1.2-2' }} €</strong></p>
      </div>
    </div>

    <div class="pf-header-actions">
      <button mat-stroked-button type="button" class="pf-btn-cancel" (click)="onCancel()" [disabled]="isSaving">
        <mat-icon>{{ dialogRef ? 'close' : 'arrow_back' }}</mat-icon> {{ dialogRef ? 'Cerrar' : 'Volver' }}
      </button>
      <button mat-flat-button type="button" class="ef-btn-save" (click)="onSave()" [disabled]="isSaving || isLoading">
        <mat-icon>save</mat-icon> Guardar
      </button>
    </div>
  </div>

  <div class="ef-body" *ngIf="!isLoading">
    <form [formGroup]="form" class="pf-form">

      <div class="pf-side-by-side">
        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">Cliente</h6>
            </div>

            <app-autocomplete [control]="form.get('contactUid')" [config]="{
                label: 'Contacto',
                placeholder: 'Buscar o crear contacto...',
                options: contacts,
                onChange: onContactChange.bind(this),
                allowCustomValues: true,
                customValueLabel: 'Crear nuevo contacto'
              }">
            </app-autocomplete>

            <p class="tk-number" *ngIf="nextTicketNumber">
              <mat-icon>receipt</mat-icon>
              <span>Se guardará con el número <strong>{{ nextTicketNumber }}</strong> o el siguiente disponible.</span>
            </p>
          </mat-card-content>
        </mat-card>

        <mat-card appearance="outlined" class="tf-card">
          <mat-card-content>
            <div class="tf-section-header">
              <h6 class="tf-section-title">Cobro</h6>
            </div>

            <div class="tk-paid">
              <app-input-checkbox [control]="form.get('paid')"
                [config]="{ label: 'Cobrado', hint: 'Registra el cobro junto con el ticket', variant: 'switch' }">
              </app-input-checkbox>
            </div>

            <ng-container *ngIf="form.get('paid').value; else unpaid">
              <div class="pf-grid-2">
                <app-autocomplete [control]="form.get('payMethodUid')" [config]="{
                    label: 'Tipo de cobro', placeholder: 'Seleccionar tipo cobro...', options: payMethods }">
                </app-autocomplete>
                <app-date [control]="form.get('date')" [config]="{ label: 'Fecha de cobro' }"></app-date>
              </div>

              <app-autocomplete *ngIf="isCashRegisterPayment()" [control]="form.get('cashRegisterUid')" [config]="{
                  label: 'Caja / Efectivo', placeholder: 'Seleccionar caja...', options: cashRegisters, autoSelectSingle: true }">
              </app-autocomplete>

              <app-autocomplete *ngIf="isBankAccountPayment()" [control]="form.get('bankAccountUid')" [config]="{
                  label: 'Cuenta bancaria', placeholder: 'Seleccionar cuenta...', options: bankAccounts, autoSelectSingle: true }">
              </app-autocomplete>

              <app-autocomplete *ngIf="isPartnerPayment()" [control]="form.get('partnerUid')" [config]="{
                  label: 'Socio', placeholder: 'Seleccionar socio...', options: partners, autoSelectSingle: true }">
              </app-autocomplete>
            </ng-container>

            <ng-template #unpaid>
              <p class="tk-unpaid">El ticket quedará pendiente de cobro. Podrás registrar el cobro desde el listado.</p>
            </ng-template>
          </mat-card-content>
        </mat-card>
      </div>

      <mat-card appearance="outlined" class="tf-card mb-3">
        <mat-card-content>
          <div class="tf-section-header ef-section__head--wrap">
            <h6 class="tf-section-title">Conceptos</h6>
            <span class="ef-section__badge" *ngIf="lines.length">{{ lines.length }}</span>
            <div class="ef-section__head-extra">
              <button mat-flat-button type="button" (click)="addLine()" class="ef-btn-add-line ef-btn-add-line--primary">
                <mat-icon>add</mat-icon> Línea
              </button>
            </div>
          </div>

          <div *ngIf="lines.length === 0" class="ef-empty-lines" [class.pf-empty-lines--invalid]="submitted">
            <mat-icon>inbox</mat-icon>
            <p>Sin conceptos. Pulsa "Línea" para comenzar.</p>
          </div>

          <ng-container *ngIf="lines.length > 0">
            <div class="lines-scroll" (scroll)="onLinesScroll($event)">
              <div formArrayName="lines" cdkDropList (cdkDropListDropped)="dropLine($event)" class="lines-container p-2">

                <div *ngFor="let line of visibleLines; let i = index; trackBy: trackByIndex"
                  [formGroupName]="i" cdkDrag
                  class="line-row line-card p-1 mb-1 border rounded">

                  <div class="line-flex">
                    <div class="drag" cdkDragHandle><mat-icon>drag_handle</mat-icon></div>

                    <div class="grow concept">
                      <app-autocomplete [control]="line.get('conceptUid')" [config]="{
                        label: 'Concepto', placeholder: 'Buscar o escribir concepto...', options: concepts,
                        allowCustomValues: true, customValueLabel: 'Usar concepto',
                        onChange: onConceptChange.bind(this, line) }">
                      </app-autocomplete>
                    </div>

                    <div class="w-qty">
                      <app-field [control]="line.get('quantity')" [config]="{ label: 'Cantidad', type: 'number' }"></app-field>
                    </div>

                    <div class="w-price">
                      <app-field [control]="line.get('price')" [config]="{ label: 'Precio', type: 'number' }"></app-field>
                    </div>

                    <div class="w-disc">
                      <app-field [control]="line.get('discount')" [config]="{ label: 'Dto.(%)', type: 'number' }"></app-field>
                    </div>

                    <div class="grow taxes">
                      <app-multi-select-autocomplete [control]="line.get('tax')" [config]="{
                        label: 'Impuestos', placeholder: 'Buscar impuesto...', options: taxes,
                        groupBy: 'group', onChange: handleTaxChange, onFocus: handleTaxFocus, lineIndex: i }">
                      </app-multi-select-autocomplete>
                    </div>

                    <div class="end">
                      <span class="ef-line-total">{{ lineTotals[i] | number:'1.2-2' }}€</span>
                      <app-button icon="delete" variant="danger" className="btn-empty" (click)="removeLine(i)"></app-button>
                    </div>
                  </div>

                </div>

              </div>
            </div>

            <div class="cf-total-cards pf-totals">
              <div class="cf-total-card">
                <p class="label">Subtotal <strong>{{ subtotal | number:'1.2-2' }} €</strong></p>
              </div>
              <div class="cf-total-card">
                <p class="label">{{ taxesLabel }} <strong>{{ taxesTotal | number:'1.2-2' }} €</strong></p>
              </div>
              <div class="cf-total-card" *ngIf="retentionsTotal !== 0">
                <p class="label">Retención <strong>{{ retentionsTotal | number:'1.2-2' }} €</strong></p>
              </div>
              <div class="cf-total-card cf-total-card--highlight">
                <p class="label">Total <strong>{{ total | number:'1.2-2' }} €</strong></p>
              </div>
            </div>
          </ng-container>

        </mat-card-content>
      </mat-card>

      <mat-card appearance="outlined" class="tf-card mb-3">
        <mat-card-content>
          <div class="tf-section-header">
            <h6 class="tf-section-title">Categorización</h6>
          </div>

          <div [class.pf-grid-2]="isProjectEnable">
            <app-autocomplete [control]="form.get('entranceAccount')" [config]="{
                label: 'Cuenta contable de ingreso', placeholder: 'Seleccionar cuenta…', options: accountingModels }">
            </app-autocomplete>

            <app-autocomplete *ngIf="isProjectEnable" [control]="form.get('projectUid')" [config]="{
                label: 'Proyecto', placeholder: 'Seleccionar proyecto...', options: projects }">
            </app-autocomplete>
          </div>
        </mat-card-content>
      </mat-card>

    </form>
  </div>

  <div class="ef-loading" *ngIf="isLoading">
    <app-loading-state message="Preparando formulario…"></app-loading-state>
  </div>

</div>
